// 方法
import { IDragDropContext } from "../context/dragDropContext";
import { getAddChange, getGridUseData, getInitOption } from "../util";
import { getEditUpdataStatus } from "../../utils/dataUtils";
// 常量
import { STATUS_CREATED, STATUS_CREATED_CODE, } from '../../constants/constant';
import { DragDropOption } from "../interface";

type actionType = 'changeMove' | 'changeOptions' | 'deleteDragItem' | 'changeWrapSize' | 'updataDragItems' | 'moveDragItems' | 'addDragItem';
export interface DragDropReducerAction {
  type: actionType;
  payload: Partial<IDragDropContext> & {
    /** 修改项名称 */
    updataName?: string;
    /** 修改参数 */
    updataConfig?: Partial<DragDropOption>,
    /** 新增项 */
    addDragItem?: DragDropOption,
    /** 删除项名称 */
    deleteName?: string,
  };
  [key: string]: any;
}
function dragDropReducer(
  state: IDragDropContext,
  action: DragDropReducerAction,
): IDragDropContext {
  const oldDragItems = state.dragItems;
  const type = action.type;
  const { updataName, updataConfig, dragItems, addDragItem, deleteName, isMove, } = action.payload;
  const baseChangeData: IDragDropContext = {...state};
  if (type !== 'changeOptions' && dragItems) {
    const gridUseData = getGridUseData(dragItems);
    baseChangeData.gridUseData = gridUseData;
  }
  switch (type) {
    case 'changeOptions':
      const initOption = getInitOption(dragItems || [], state.grid);
      return {
        ...baseChangeData,
        dragItems: initOption.map(item => {
          return {
            ...item,
            [STATUS_CREATED_CODE]: item[STATUS_CREATED_CODE] || STATUS_CREATED.DEFAULT,
          };
        }),
        gridUseData: getGridUseData(initOption),
      };
    case 'changeMove':
      return {
        ...baseChangeData,
        isMove,
      };
    case 'changeWrapSize':
      const wrapWidht = action.payload.wrapWidht || document.body.clientWidth;
      const difWidth = Math.floor(((wrapWidht - 8) / (state.grid || 12)) * 1000) / 1000;
      const columnWidth = difWidth - 8;
      return {
        ...baseChangeData,
        ...action.payload,
        width: columnWidth,
      };
    case 'moveDragItems':
      if (!updataConfig) return state;
      const findItem = oldDragItems.find(item => item.name === updataName);
      if (!findItem) return state;
      return {
        ...baseChangeData,
        dragItems: oldDragItems.map(item => {
          if (item.name === updataName) {
            return { ...item, ...updataConfig, [STATUS_CREATED_CODE]: getEditUpdataStatus(item[STATUS_CREATED_CODE]), };
          }
          if (
            item.left === updataConfig.left &&
            item.top === updataConfig.top &&
            (item.column || 1) <= (updataConfig.column || 1) &&
            (item.row || 1) <= (updataConfig.row || 1)
          ) {
            return {
              ...item,
              left: findItem.left,
              top: findItem.top,
              [STATUS_CREATED_CODE]: getEditUpdataStatus(item[STATUS_CREATED_CODE]),
            };
          }
          return item;
        }),
      };
    case 'updataDragItems':
      return {
        ...baseChangeData,
        dragItems: oldDragItems.map(item => {
          if (item.name === updataName) {
            return { ...item, ...updataConfig, [STATUS_CREATED_CODE]: getEditUpdataStatus(item[STATUS_CREATED_CODE]), };
          }
          return item;
        }),
      };
    case 'addDragItem':
      if (!addDragItem) return state;
      const addInfo = getAddChange(addDragItem, state.gridUseData || [], state.grid);
      const newAddDragItems: DragDropOption[] = [
        ...oldDragItems,
        {
          ...addDragItem,
          ...addInfo,
          [STATUS_CREATED_CODE]: addDragItem[STATUS_CREATED_CODE] || STATUS_CREATED.ADD,
        },
      ];
      return {
        ...state,
        dragItems: newAddDragItems,
        gridUseData: getGridUseData(newAddDragItems),
      };
    case 'deleteDragItem':
      if (!deleteName) return state;
      const newDeleteDragItems: DragDropOption[] = [];
      oldDragItems.forEach(item => {
        if (item.name === deleteName) {
          if (item[STATUS_CREATED_CODE] !== STATUS_CREATED.ADD) {
            newDeleteDragItems.push({ ...item, [STATUS_CREATED_CODE]: STATUS_CREATED.DELETE, });
          }
        } else {
          newDeleteDragItems.push(item);
        }
      });
      return {
        ...state,
        dragItems: newDeleteDragItems,
        gridUseData: getGridUseData(newDeleteDragItems),
      };
    default: {
      return state;
    }
  }
}

export default dragDropReducer;
